<template>
  <div class="ts-bg-white">
    <section>
      <div
        class="ts-py-24 ts-bg-no-repeat ts-bg-cover"
        :style="{
        'background-image':
          'url(' + require('@/assets/front/images/inner-page-bg.jpg') + ')'
      }"
      >
        <div class="ts-container ts-mx-auto ts-px-4">
          <h2 
             :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font'"
            class="ts-text-4xl sm:ts-text-6xl"
          >{{ $t('front.aboutUs') }}</h2>
          <ts-breadcrumb
            :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
            class="ts-text-base"
            :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('front.aboutUs'),
            active: true
          }
        ]"
          />
        </div>
      </div>
    </section>
    <section class="ts-py-12 lg:ts-py-32">
      <div class="ts-container ts-mx-auto">
        <a-skeleton :active="active" :loading="active" width="60px" :paragraph="{ rows: 15 }" />
      </div>
      <div v-if="!active" class="ts-px-4 xl:ts-px-0 xl:ts-flex xl:ts-justify-between">
        <div class="xl:ts-w-5/12">
          <div class="thumb ts-overflow-hidden xl:ts-rounded-tr-3xl xl:ts-rounded-br-3xl">
            <img class="ts-object-cover ts-object-center ts-mx-auto" :src="getImage" @error="setNoImage" alt />
          </div>
        </div>
        <div class="xl:ts-w-6/12">
          <h1
            :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen sm:ts-text-3xl ts-font-medium' : 'ts-font-heading-font sm:ts-text-4xl'"
            class="ts-mt-10 xl:ts-mt-0 ts-text-gray-700"
          >{{ $t('front.aFewWordsAboutUs') }}</h1>
          <div
            :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
            class="ts-pr-8 ts-mt-6 ts-text-base xl:ts-w-2/3 ts-leading-7"
            v-html="resource.contents"
          ></div>
        </div>
      </div>
    </section>
    <ChooseUs />
  </div>
</template>

<script>
import ChooseUs from './components/choose-us'
export default {
  name: 'aboutUs',
  components: {
    ChooseUs
  },
  data() {
    return {
      resource: {},
      active: false,
      no_image: require('@/assets/front/images/no_image.png')
    }
  },
  computed: {
    getImage() {
      if (this.resource.thumbnail_url) {
        return this.resource.thumbnail_url
      } else {
        return this.no_image
      }
    },
    langId(){
      return this.$store.state.languages
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.active = true
      await this.$store
        .dispatch('front/contentManagement/fetch', {
          filter: {
            content_type_id: 1,
            lang_id: this.$store.state.languages[this.$root.$i18n.locale]
          }
        })
        .then(response => {
          this.resource = response.data
          this.active = false
        })
    },
    setNoImage(event) {
      event.target.src = this.no_image
    }
  },
  watch: {
    '$root.$i18n.locale': function(){
      this.fetchData()
    }
  }
}
</script>
